import {
  Select,
  SelectBackdrop,
  SelectContent,
  SelectDragIndicator,
  SelectDragIndicatorWrapper,
  SelectInput,
  SelectItem,
  SelectPortal,
  SelectScrollView,
  SelectTrigger,
  View,
} from '@gluestack-ui/themed'
import React, { FunctionComponent, PureComponent } from 'react'
import { StyleSheet } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import Ionicons from 'react-native-vector-icons/Ionicons'
import { FormSelect } from '../../api/Form/types'
import { i18n } from '../../lib/i18n'
import { LabelInput } from './components'
import { FormElementProps } from './types'

const SelectSheet: FunctionComponent<{ field: FormSelect; items: FormSelect['items'] }> = ({ field, items }) => {
  const insets = useSafeAreaInsets()

  return (
    <SelectPortal>
      <SelectBackdrop />
      <SelectContent style={{ paddingBottom: insets.bottom }}>
        <SelectDragIndicatorWrapper>
          <SelectDragIndicator />
        </SelectDragIndicatorWrapper>
        <SelectScrollView style={styles.scroll}>
          {items.map(item => (
            <SelectItem key={`picker-item-${field.id}-${item.id}`} label={item.libelle} value={item.id?.toString() as string} />
          ))}
        </SelectScrollView>
      </SelectContent>
    </SelectPortal>
  )
}

class SelectFieldClass extends PureComponent<FormElementProps<FormSelect>> {
  public focus = () => {}

  public render() {
    const { field, value } = this.props

    const items = [...(field.items || [])]

    items.unshift({
      libelle: i18n.t('form.selectItem'),
    })

    return (
      <View style={styles.container}>
        <View style={styles.left}>
          <LabelInput text={field.libelle} required={field.constraint.mandatory} />
        </View>
        <View style={styles.right}>
          <Select selectedValue={value as string} onValueChange={itemValue => this.props.setFieldValue(this.props.name, itemValue)}>
            <SelectTrigger>
              <SelectInput placeholder={i18n.t('form.selectItem')} numberOfLines={1} />
              <View style={styles.selectIcon}>
                <Ionicons name="chevron-down" size={20} />
              </View>
            </SelectTrigger>
            <SelectSheet field={field} items={items} />
          </Select>
        </View>
      </View>
    )
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
  },
  left: {
    flex: 1,
    justifyContent: 'center',
  },
  right: {
    flex: 1,
    justifyContent: 'flex-end',
  },
  selectIcon: {
    paddingRight: 12,
  },
  scroll: {
    maxHeight: 350,
  },
})

export const SelectField = SelectFieldClass
